import { types } from "../Helpers/Types";

const initialState = {
  mensaje: "CARGANDO",
  mostrar: false,
};

export const LoadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.Loading: {
      return {
        ...state,
        mostrar: action,
      };
    }
    default:
      return state;
  }
};
